import React from 'react';
import {Box, Divider, List, ListItem, ListItemIcon, ListItemText} from '@mui/material';
import Icon from 'presentation/icons';
import {CounterButton} from 'presentation/pages/public/sign-up/components';
import {translations} from 'presentation/translations-new';
import {ContentStack, ResendTokenButtonContainer} from './styles';
import {ResendTokenCheckListItemType, ResendTokenContentProps} from './types';

const {resendToken} = translations['pt-br'].publicFlow;

export function ResendTokenContent({
	isSubmitting,
	handleAction,
	privateFlow,
}: ResendTokenContentProps) {
	const CHECKLIST_ITEMS: ResendTokenCheckListItemType[] = [
		{
			icon: 'error-fill',
			text: resendToken.item1,
		},
		{
			icon: 'mail-filled',
			text: resendToken.item2,
		},
		{
			icon: 'dialog-filled',
			text: resendToken.item3,
		},
		{
			icon: 'clock-filled',
			text: resendToken.item4,
		},
	];

	return (
		<ContentStack alignItems="center" spacing={2} $privateFlow={privateFlow}>
			<List
				disablePadding
				sx={{
					width: privateFlow ? '100%' : 'auto',
				}}>
				{CHECKLIST_ITEMS.map((item: ResendTokenCheckListItemType, index: number) => (
					<Box key={index}>
						<ListItem disableGutters>
							<ListItemIcon>
								<Icon name={item.icon} />
							</ListItemIcon>
							<ListItemText primary={item.text} />
						</ListItem>
						{index < CHECKLIST_ITEMS.length - 1 ? <Divider /> : null}
					</Box>
				))}
			</List>
			<ResendTokenButtonContainer $privateFlow={privateFlow}>
				<CounterButton handleAction={handleAction} isSubmitting={isSubmitting} />
			</ResendTokenButtonContainer>
		</ContentStack>
	);
}
